import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { bootstrapDevModule } from './setup/dev.bootstrap';
import { bootstrapProdModule } from './setup/prod.bootstrap';
import { environment } from './environments/environment';

import { AppModule } from './app/application/app.module';

if (environment.production) {
  bootstrapProdModule();
} else {
  bootstrapDevModule();
}

document.write(`
<script type="text/javascript">
        (function(i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r;
            i[r] = i[r] || function() {
                (i[r].q = i[r].q || []).push(arguments)
            }, i[r].l = 1 * new Date();
            a = s.createElement(o),
                m = s.getElementsByTagName(o)[0];
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m)
        })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

        ga('create', '${environment.gaID}', 'auto');

        if (location.hostname == 'localhost') {
            //ga('set', 'sendHitTask', null); // if dont want to send data to google Analytics
        }
        
</script>`);

const hackThis = false;
if (hackThis) {
  platformBrowserDynamic().bootstrapModule(AppModule);
}




// WEBPACK FOOTER //
// ./src/main.ts